export default {
    async get() {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
                (location) => {
                    resolve([location.coords.latitude, location.coords.longitude]);
                },
                (error) => {
                    reject(error);
                },
                {
                    enableHighAccuracy: true,
                    // timeout: 1000,
                    // maximumAge: 0,
                }
            );
        });
    }
};